/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../";
export function IconArtistActive(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M0 16v-.672a3.999 3.999 0 0 1 2-3.463l3.112-1.8a1.2 1.2 0 0 0 .322-1.807l-.487-.585a5.367 5.367 0 0 1-1.353-3.175 5.3 5.3 0 0 1 .2-1.776c.172-.525.453-1.01.823-1.42a4.016 4.016 0 0 1 5.92 0c.37.41.65.895.823 1.42a5.3 5.3 0 0 1 .2 1.776 5.367 5.367 0 0 1-1.353 3.175l-.487.585A1.2 1.2 0 0 0 9.6 9.62l-.008.007A5.486 5.486 0 0 0 8.607 16H0zm14.72-9.029a.75.75 0 0 1 1.28.53v6a2.499 2.499 0 1 1-2.5-2.5h1V7.5a.75.75 0 0 1 .22-.53z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M14.3 14.28a5.968 5.968 0 0 0 .237 7.717H1v-1.6a4 4 0 0 1 2-3.465l4.8-2.763a1.5 1.5 0 0 0 .4-2.26l-.7-.835a7.046 7.046 0 0 1-1.775-4.17 6.906 6.906 0 0 1 .264-2.33 5.211 5.211 0 0 1 1.08-1.865 5.27 5.27 0 0 1 7.77 0c.486.54.854 1.175 1.08 1.865.22.756.308 1.544.263 2.33a7.047 7.047 0 0 1-1.775 4.17l-.7.835a1.498 1.498 0 0 0 .4 2.26l.193.111zm5.993-4.686a1 1 0 0 1 1.707.707v7.666a3 3 0 1 1-3-3h1v-4.666a1 1 0 0 1 .293-.707z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconArtistActive is deprecated and will be archived soon. Use IconArtistActive instead.
 */
export function Experimental__IconArtistActive(props) {
  return /*#__PURE__*/React.createElement(IconArtistActive, props);
}